import RealEstateCommissionInstallmentsAPI from 'dashboard/api/realEstateCommissionInstallments';
import { formToSheet, sheetToForm } from './commissionSheetForm';

export const installmentErrorMessage = (error, fallback) =>
  error?.response?.data?.errors?.[0] ||
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  fallback;

export function useRealEstateCommissionInstallmentData({
  canEdit,
  catalog,
  error,
  form,
  id,
  installment,
  loading,
  loadingCatalog,
  notify,
  saving,
  t,
}) {
  const notifyError = (requestError, fallback) => {
    error.value = installmentErrorMessage(
      requestError,
      fallback || t('REAL_ESTATE_COMMISSION_INSTALLMENT.ERRORS.LOAD')
    );
    notify(error.value, null, { variant: 'error' });
  };

  const apply = data => {
    installment.value = data;
    form.value = sheetToForm(data.sheet || data);
  };

  const load = async () => {
    if (!id.value) return null;

    loading.value = true;
    error.value = '';
    try {
      const response = await RealEstateCommissionInstallmentsAPI.show(id.value);
      apply(response.data?.data || {});
      return installment.value;
    } catch (requestError) {
      notifyError(requestError);
      return null;
    } finally {
      loading.value = false;
    }
  };

  const loadCatalog = async () => {
    loadingCatalog.value = true;
    try {
      const response = await RealEstateCommissionInstallmentsAPI.catalog();
      catalog.value = response.data?.data || {};
    } catch (requestError) {
      notifyError(
        requestError,
        t('REAL_ESTATE_COMMISSION_INSTALLMENT.ERRORS.CATALOG')
      );
    } finally {
      loadingCatalog.value = false;
    }
  };

  const save = async ({ silent = false } = {}) => {
    if (!id.value || !canEdit.value || saving.value) return null;

    saving.value = true;
    try {
      const response = await RealEstateCommissionInstallmentsAPI.updateSheet(
        id.value,
        formToSheet(form.value)
      );
      apply(response.data?.data || installment.value);
      if (!silent) {
        notify(t('REAL_ESTATE_COMMISSION_INSTALLMENT.ALERTS.SAVED'), null, {
          variant: 'success',
        });
      }
      return installment.value;
    } catch (requestError) {
      notifyError(
        requestError,
        t('REAL_ESTATE_COMMISSION_INSTALLMENT.ERRORS.SAVE')
      );
      return null;
    } finally {
      saving.value = false;
    }
  };

  return { apply, load, loadCatalog, notifyError, save };
}
